import React from 'react';
import PropTypes from 'prop-types';
import { MAIN_COLOR } from '../../../styles/variables';

const SendIcon = ({ color, size }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30">
      <defs>
        <path
          id="SendIconA"
          d="M20.085 17.533l5.535-5.427-5.535-5.428V9.45l-1.784.002c-7.097.008-12.904 5.356-13.47 12.14 3.133-4.13 7.883-6.845 12.77-6.833h2.484v2.774zM18.3 20.806v-4.261h-1.785v.048c-5.001.454-9.488 4.068-11.79 8.493l-.942 1.8A.416.416 0 0 1 3 26.701v-4.034c.01-8.28 6.854-14.991 15.3-15V3.404c0-.164.1-.311.255-.374a.42.42 0 0 1 .45.088l8.874 8.7a.4.4 0 0 1 0 .573l-8.874 8.7a.42.42 0 0 1-.45.089.405.405 0 0 1-.256-.375z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="SendIconB" fill="#fff">
          <use xlinkHref="#SendIconA" />
        </mask>
        <use fill={color || MAIN_COLOR} fillRule="nonzero" xlinkHref="#SendIconA" />
        <g fill={color || MAIN_COLOR} mask="url(#SendIconB)">
          <path d="M0 0h30v30H0z" />
        </g>
      </g>
    </svg>
  );
};

SendIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

SendIcon.defaultProps = {
  color: MAIN_COLOR,
  size: '30px',
};

export default SendIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Send/index.js